/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceMailingSettings
 */
export interface InvoiceMailingSettings {
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceMailingSettings
     */
    sendInvoiceByEmailToClient: boolean;
}

/**
 * Check if a given object implements the InvoiceMailingSettings interface.
 */
export function instanceOfInvoiceMailingSettings(value: object): value is InvoiceMailingSettings {
    if (!('sendInvoiceByEmailToClient' in value) || value['sendInvoiceByEmailToClient'] === undefined) return false;
    return true;
}

export function InvoiceMailingSettingsFromJSON(json: any): InvoiceMailingSettings {
    return InvoiceMailingSettingsFromJSONTyped(json, false);
}

export function InvoiceMailingSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceMailingSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'sendInvoiceByEmailToClient': json['sendInvoiceByEmailToClient'],
    };
}

export function InvoiceMailingSettingsToJSON(value?: InvoiceMailingSettings | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'sendInvoiceByEmailToClient': value['sendInvoiceByEmailToClient'],
    };
}

